import React, {Fragment} from 'react';
import {MemoryRouter} from 'react-router-dom';
import {useLoadedEvents} from '../../../data/hooks/eventHooks';
import Screen from '../../screens/Screen';

import LoadChatSessions from '../LoadChatSessions';
import LoadConnections from '../LoadConnections';
import LoadEnrichments from '../LoadEnrichments';
import LoadEvent from '../LoadEvent';
import LoadEventConnections from '../LoadEventConnections';
import LoadEventFormsMetadata from '../LoadEventFormsMetadata';
import LoadEventLiveVoting from '../LoadEventLiveVoting';
import LoadExhibitors from '../LoadExhibitors';
import LoadLocations from '../LoadLocations';
import LoadMeetings from '../LoadMeetings';
import LoadNews from '../LoadNews';
import LoadParticipants from '../LoadParticipants';
import LoadProgram from '../LoadProgram';
import LoadQAQuestions from '../LoadQAQuestions';
import LoadSpeakers from '../LoadSpeakers';

const LoadTest = props => {
    const loadedEvents = useLoadedEvents();

    return (
        <MemoryRouter>
            <Screen>
                <code>Load test</code>
            </Screen>
            <LoadChatSessions />
            <LoadConnections />
            {loadedEvents.map(eventId => (
                <Fragment key={eventId}>
                    <LoadEvent eventId={eventId} />
                    <LoadEnrichments eventId={eventId} />
                    <LoadEventConnections eventId={eventId} />
                    <LoadEventFormsMetadata eventId={eventId} />
                    <LoadEventLiveVoting eventId={eventId} />
                    <LoadExhibitors eventId={eventId} />
                    <LoadLocations eventId={eventId} />
                    <LoadMeetings eventId={eventId} />
                    <LoadNews eventId={eventId} />
                    <LoadParticipants eventId={eventId} />
                    <LoadProgram eventId={eventId} />
                    <LoadQAQuestions eventId={eventId} />
                    <LoadSpeakers eventId={eventId} />
                </Fragment>
            ))}
        </MemoryRouter>
    );
};

export default LoadTest;
